/**
 * Main thread code for managing providers of elevation annotation SVG data. This doesn't create the worker directly, since that code doesn't work in a node.js environment.
 * @module
 */
import type { PlanGeometryGeneratorResult } from "doc/plans/planGeometrySourceTypes";
import { elevationAutoAnnotationPlanGeometry } from "lib/house/svg/elevationAnnotationSVG";
import type { ElevationAnnotationProvider, ElevationAnnotationProviderParams } from "./elevationAnnotationTypes";

// Re-export for backwards compatibility
export type { ElevationAnnotationProviderParams, ElevationAnnotationProvider } from "./elevationAnnotationTypes";

class ElevationAnnotationSyncProvider implements ElevationAnnotationProvider {
  async getPlanGeometry(params: ElevationAnnotationProviderParams): Promise<PlanGeometryGeneratorResult> {
    return elevationAutoAnnotationPlanGeometry(params);
  }
}

let annotationProviderWithWorker: ElevationAnnotationProvider;
let annotationProviderWithoutWorker: ElevationAnnotationProvider;

export function hasSetElevationAnnotationProviderWithWorker(): boolean {
  return annotationProviderWithWorker !== undefined;
}

export function setElevationAnnotationProviderWithWorker(provider: ElevationAnnotationProvider) {
  annotationProviderWithWorker = provider;
}

export function getElevationAnnotationProvider(): ElevationAnnotationProvider {
  if (annotationProviderWithWorker !== undefined) {
    return annotationProviderWithWorker;
  } else {
    if (annotationProviderWithoutWorker === undefined) {
      annotationProviderWithoutWorker = new ElevationAnnotationSyncProvider();
    }
    return annotationProviderWithoutWorker;
  }
}
